export default __webpack_public_path__ + "static/media/para_4872_bp.a68072a1.svg";